import React, { Component } from "react";
import { IImage } from "src/models";

export interface DynamicImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  image: IImage;
}

export class DynamicImage extends Component<DynamicImageProps> {
  render() {
    const { image, alt, ...rest } = this.props;
    if (!image) {
      return null;
    }

    return <img src={image.mediaItemUrl} alt={image.altText || alt} {...rest} />;
  }
}
